import React from "react";
import { Body } from "components/src/components/Typography/Typography";
import { Icon } from "components/src/components/Icon/Icon";

export const LiveStreamIcon = ({className, text = "Livestream Available" , minimal}: { className?: string, minimal?: boolean, text?: string }) => (
    <Body
      size="xs-bold"
      className={`${!minimal ? "cui-absolute -cui-bottom-4": ""} cui-m-0 cui-flex cui-items-center cui-whitespace-nowrap ${className}`}
      color="fg-moderate"
    >
      <Icon
        name="ui_watch"
        size="sm"
        color="highlight-accent"
        className="cui-mr-2xs"
      />
      {text}
    </Body>
  );